module.exports = __webpack_public_path__ + "static/assets/cc6084c5a245a9b1310a5ff54b74b894.png";